import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'
import Auth from './auth'
import User from './user'
//import Locale from './locale'

Vue.use(Vuex)

export const plugins = [
    createPersistedState({
        storage: {
            getItem: function (key) {
                //console.log('storage2')
                return Cookies.get(key)
            },
            setItem: (key, value) => Cookies.set(key, value, { expires: 3 }),
            removeItem: key => Cookies.remove(key)
        }
    })
]

const createStore = () => {
    return new Vuex.Store({
        modules: {
            Auth,
            User
            //Locale
        },
        state: {
            locale: Cookies.get('lang') || navigator.language
        },
        getters: {
            getLang: state => state.locale
        },
        mutations: {
            setLang (state, locale) {
                state.locale = locale;
                Cookies.set('lang', locale, { expires: 360 })
            }
        }
        //plugins
    })
}

export default createStore
